export default {
  quantity: {
    system: {
      name: 'quantity',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'quantity',
    rules: {
      title: 'Quantity field',
      required: true,
    }
  },
  unit_of_measure: {
    system: {
      name: 'unit_of_measure',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'unit_of_measure',
    rules: {
      title: 'Unit',
      required: true,
    }
  },
  price: {
    prefix: '$',
    system: {
      name: 'price',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'price',
    rules: {
      title: 'Price field',
      required: true,
    }
  },
  subtotal: {
    prefix: '$',
    system: {
      name: 'subtotal',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'subtotal',
    rules: {},
  },
};



// WEBPACK FOOTER //
// ./src/common/Materials/fields.js